export const adap_bodega_guia = ({bodega, pedido}) => {

    let obj = {

        "quote_token": pedido.tokenEnvio,
        "content": bodega.contenido,
        "origin_name": bodega.nombres,
        "origin_last_name": bodega.apellidos,
        "origin_email": bodega.correo,
        "origin_street": bodega.calle,
        "origin_number": bodega.numero,
        "origin_neighborhood": bodega.barrio,
        "origin_phone": bodega.celular,
        "origin_state": bodega.estado,
        "origin_municipality": bodega.municipio,
        "origin_references": bodega.referencia,
        "destination_name": pedido.nombres,
        "destination_last_name": pedido.apellidos,
        "destination_email": pedido.correo,
        "destination_street": pedido.calle,
        "destination_number": pedido.numero,
        "destination_neighborhood": pedido.barrio,
        "destination_phone": pedido.celular,
        "destination_state": pedido.estadoMexico,
        "destination_municipality": pedido.municipio,
        "destination_references": pedido.referencia,
        "packages": 1,
        "generate_pickup": false,
        "has_notification": true,
        "guide_origin": "t1envios"

    }

    return obj

}